import { ReactComponent as Icon } from 'assets/icons/document16.svg'

export const DocumentIcon = ({ className }: { className?: string }) => {
  return <Icon className={className} />
}
